module.exports = __webpack_public_path__ + "static/img/law-society-scotland.55c5007.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/home-page-logos/law-society-scotland.png
// module id = 0ULr
// module chunks = 0